<!--
 * @FileDescription: 已失效的优惠券
 * @Author: 陈文景
 * @Date: 2023-03-18 14:43:14
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div>
    <ul v-if="coupons.length" :class="['expired', { 'is-mobile': !isPC }]">
      <CouponItem v-for="coupon in coupons" :key="coupon.id" :coupon="coupon" />
    </ul>

    <!-- 空状态 -->
    <template v-else>
      <div class="not-data">
        <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" :style="{ width: isPC ? '28%' : '68%' }" alt="img.svg" />
        <span class="tips-text">NoRecord</span>
      </div>
    </template>
  </div>
</template>

<script>
import API from '@/api'
import CouponItem from '@/components/CouponItem.vue'

export default {
  components: {
    CouponItem
  },
  data() {
    return {
      // 获取优惠券列表的请求参数
      parameter: {
        selectStatus: 2 // 客户优惠券查询状态：0.可用优惠券 1.已用优惠券 2.失效优惠券
      },

      // 优化券列表
      coupons: [
        // {
        //   id: 1, // 优惠券ID
        //   selected: false, // 是否选择使用该优惠券（发起请求前需要删除该字段！）
        //   couponTicketName: undefined, // 优惠券名称
        //   usableStartTime: 1679129046000, // 可用开始时间
        //   usableEndTime: 1684399446000, // 可用结束时间
        //   status: 2, // 客户优惠券状态：0.可用 1.已使用 2.已过期 3.已作废
        //   logoUrl: 'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg', // 优惠券图标
        //   // 领取使用规则
        //   receiveUsageRules: {
        //     // 使用条件（门槛）
        //     overlayUseTypes: [], // 优惠叠加
        //     conditionsOfUse: {
        //       useType: 2, // 使用类型：1.无使用门槛 2.订单满多少钱减 3.订单满多少件减
        //       threshold: 100 // 阀值
        //     },
        //     // 适用的商品
        //     applicableProducts: {
        //       applicableType: 1 // 适用商品类型：1.全部商品可用 2.非全部活动商品可用 3.指定商品
        //     },
        //     // 优惠的内容
        //     offerTypeInfo: {
        //       fixedType: 1, // 优惠内容类型：1.固定减价 2.固定折扣
        //       reduction: 68 // 减少量
        //     }
        //   }
        // }
      ],
      loading: false // 优惠券列表加载效果
    }
  },
  methods: {
    /**
     * API 获取优惠券列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getCouponsList() {
      try {
        this.loading = true
        let { data } = await API.getCouponsList(this.parameter)
        if (data && data.length) {
          this.coupons = data
        } else {
          this.coupons = []
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 负责在Tabs切换时重新获取数据
     */
    update() {
      this.getCouponsList()
    }
  }
}
</script>

<style lang="scss" scoped>
.expired {
  display: grid;
  grid-gap: 12px 12px;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 364px);
  &.is-mobile {
    justify-content: center;
    grid-template-columns: repeat(auto-fill, 100%);
  }
}

.not-data {
  display: flex;
  width: 100%;
  height: 100%;
  margin-top: 28px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .tips-text {
    color: #747a87;
    font-size: 14px;
    margin-top: 18px;
  }
}
</style>
